
import { Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { TournamentService } from '../gamer/services/tournament.service';
import { CreatePlayerComponent } from './components/create-player/create-player';
import { CreateTeamComponent } from './components/create-team/create-team';
import { SettingsComponent } from './components/toolbar/settings/toolbar-settings';
import { IActivity, IGrid, IPlayer, ITeam, LineUpService, ToolbarType } from './services/lineup-service';
import { activities } from './services/lineup-service';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { LineTestPage } from './testpage/test-lineup';
import domtoimage from 'dom-to-image';
import { SessionProvider } from '../../../providers/session/session';
import { Router } from '@angular/router';

const $blockNum = 36;

@Component({
    selector: 'lineup-area',
    templateUrl: 'lineup.html',
    styleUrls:['./lineup.scss']
})
export class LineupPage {
    @ViewChild('bounds') bounds;
    // temporary 
    gamer:any;

    isMoving: boolean = false;
    activeTeam: number = 0;
    activePlan: number = 0;
    activeToolbar: ToolbarType = ToolbarType.tshirt;
    activities: IActivity[] = activities;
    players = [];

    grid: IGrid = {
        activeBlock: -1,
        length: $blockNum,
        blocks: new Array($blockNum)
    };
    pReload = true;

    constructor(
        private modalCtrl: ModalController,
        public ls: LineUpService,
        public gs: TournamentService,
        private router:Router,
        private navCtrl: NavController,
        private translate: TranslateService,
        private sessionService: SessionProvider,
        private loadCtrl: LoadingController,
        private socialSharing: SocialSharing,
    ) {
        this.initSubs();
        this.loadCtrl.create({}).then(loader=>{
            loader.present();
            this.gs.getPlanList().then(t => {
                this.reload();
                loader.dismiss();
                this.onChange();
            }).catch(e => {
                loader.dismiss();
            });
        });
    }

    onOpenTestPage() {
        var node = document.getElementById('export');
        let that = this;
        domtoimage.toPng(node)
            .then(function (dataUrl) {
                var img = new Image();
                img.src = dataUrl;
                that.router.navigate(['/line-test'],{state:{context:img.src}});
                // that.navCtrl.push(LineTestPage, { context: img.src })
                // document.body.appendChild(img);
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    ionViewWillEnter() {
        this.loadCtrl.create({}).then(loader=>{
            loader.present();
            this.reload();
            this.onChange();
            loader.dismiss();
        });
    }

    reload() {
        this.pReload = false;
        setTimeout(() => {
            this.pReload = true
        });
    }

    initSubs() {
        this.ls.updateSub.subscribe(() => {
            this.reload();
        });
        this.ls.changeMenuSub.subscribe((configs: {
            type: ToolbarType,
            activePlan: number,
            activeTeam: number
        }) => {
            this.activeToolbar = configs.type;
            this.activePlan = configs.activePlan;
            this.activeTeam = configs.activeTeam;
            this.reload();
        });
    }

    saveLineupPic() {
        setTimeout(() => {
            let node = document.getElementById('exportlineup');
            let id = this.gs.planList[this.activePlan].teams[this.activeTeam].id;
            let name = this.gs.planList[this.activePlan].teams[this.activeTeam].name.trim() + '-' + id + ".png";
            domtoimage.toPng(node)
                .then(dataUrl => {
                    let img = new Image();
                    img.src = dataUrl;
                    img.crossOrigin = "anonymous"
                    this.gs.saveTreeImage(id, { id: -1, imageLink: img.src, name: name })
                    .catch(err => console.warn(err));
                })
                .catch(error => console.log(error));
        }, 200);
    }

    async addPlayer(player: IPlayer = null) {
            let modal = await this.modalCtrl.create({component:CreatePlayerComponent, componentProps:{
                activePlan: this.activePlan,
                activeTeam: this.gs.planList[this.activePlan] ? this.activeTeam : null,
                player: player
            }});
            modal.present();
            modal.onDidDismiss().then(() => {
                this.reload();
                this.onChange();
            });
    }

    async addTeam(team: ITeam = null) {
        let modal = await this.modalCtrl.create({component:CreateTeamComponent, componentProps:{
            plan: this.activePlan,
            team: team
        }});
        modal.present();
        modal.onDidDismiss().then(() => {
            this.reload();
        });
    }

    getAddPlayerText() {
        return this.translate.instant('ADD_PLAYER');
    }

    getAddTeamText() {
        return this.translate.instant('ADD_TEAM');
    }

    getToolbarPlanName() {
        return this.gs.planList.length ? this.gs.planList[this.activePlan].name : this.translate.instant('NO_TURNIERS_YET');
    }

    getToolbarTeamName() {
        return this.gs.getTeamName(this.activePlan, this.activeTeam);
    }

    onPlanSelect(event) {
        this.activePlan = event;
        this.reload();
        this.onChange();
    }

    onTeamSelected(event) {
        this.activeTeam = event;
        this.reload();
        this.onChange();
    }

    addPlan() {
        this.navCtrl.navigateForward('/tab1');
        // (this.app.getRootNav() as NavController).popToRoot();
        // this.app.getRootNav().getActiveChildNav().select(1);
    }

    onTeamSelect(event: any) {
        this.activeTeam = this.gs.planList[this.activePlan].teams.findIndex(x => x.id == event.id && x.name == event.name);
        this.addTeam(event);
        this.onChange();
    }

    openSettings() {
        this.sessionService.getToken(false, false).then((token) => {
            if(token){
               this.navCtrl.navigateForward('/lineup/settings', {state:{activePlan: this.activePlan, activeTeam: this.activeTeam }});
            }else{
                this.navCtrl.navigateForward('/auth/login');
                this.sessionService.setPostLoginAction(()=>{
                this.openSettings()
                })
            }
        })
    }

    onActionClick(type: ToolbarType) {
        switch (type) {
            case ToolbarType.settings: this.openSettings(); break;
            case ToolbarType.share: this.share(); break;
            default: this.activeToolbar = type; break;
        }
    }

    share() {
        this.takeScreenshot();
    }

    takeScreenshot() {
        // this.screenshot.save('jpg', 80, 'myscreenshot.jpg').then((event) => {
        //     let element = document.querySelector('field-image')[0];
        //     this.crop.crop(event.filePath, {
        //         targetHeight: 200
        //     }).then((value) => {
        //         this.socialSharing.share('', '', value);
        //     })
        // });
    }

    async onActivityChange(activity) {
        let loader = await this.loadCtrl.create({});
        loader.present();
        this.gs.planList[this.activePlan].sporttype = activity.id;
        this.gs.save();
        this.gs.saveTou(this.gs.planList[this.activePlan])
        .then(plan => {
            this.gs.planList[this.activePlan] = plan;
            loader.dismiss();
        }).catch(err => {
            console.warn('err: ', err);
            loader.dismiss();
        })
        this.onChange();
    }

    onChange() {
        setTimeout(() => {
            if (!this.gs.planList[this.activePlan] || !this.gs.planList[this.activePlan].teams[this.activeTeam]) return;
            for (let i = 0; i < this.gs.planList[this.activePlan].teams[this.activeTeam].players.length; i++) {
                this.paintPlayer('player' + i, this.gs.planList[this.activePlan].teams[this.activeTeam].players[i].color1, this.gs.planList[this.activePlan].teams[this.activeTeam].players[i].color2);
            }
        }, 100);
    }

    onLocationChange(player) {
        this.grid.activeBlock = this.isOver(player);
    }

    onMovingSetState(state) {
        console.log('state', state)
        this.isMoving = state;
        console.log('onMoving');
    }

    onSavePlayer(player){
        this.gs.savePlayer(player);
        this.saveLineupPic();
    }

    sort(teams: any, players: boolean = true) {
        if (!teams) return [];

        return teams.sort((a, b) => a.id - b.id);
    }

    isOver(player) {
        for (let i = 0; i < this.grid.length; i++) {
            let block = document.getElementById('block-' + i);
            let pCoords = player.getBoundingClientRect();
            let bCoords = block.getBoundingClientRect();

            let leftB = bCoords.left;
            let rightB = bCoords.right;
            let topB = bCoords.top - 60;
            let bottomB = bCoords.bottom - 60;

            let xP = pCoords.left + 12;
            let yP = pCoords.top - 30;

            if ((leftB < xP && rightB > xP) && (topB < yP && bottomB < yP)) return i;
        }
        return -1;
    }

  

    paintPlayer(id, color1, color2) {
        let el = document.getElementById(id).getElementsByClassName('svg-icon-primary')[0] as HTMLElement;
        if (el.classList.contains('svg-icon-primary')) el.classList.remove('svg-icon-primary');
        el.setAttribute("fill", color1);

        let el2 = document.getElementById(id).getElementsByClassName('svg-icon-secondary');
        for (let i = 0; i < el2.length; i++) {
            let x = el2[i] as HTMLElement;
            if (x.classList.contains('svg-icon-secondary')) x.classList.remove('svg-icon-secondary');
            x.setAttribute("fill", color2);
        }
    }

    public get toolbar(): typeof ToolbarType {
        return ToolbarType;
    }
}

